// Shared reducer for streamed person-brief SSE frames, used by both the
// org-chart drawer and the /pre-meeting-brief page so the assembly logic can't
// drift between them. Mutates and returns `partial` for the data-bearing
// frames (meta/enrich/news/summary); the caller handles `done`/`error`, which
// carry no brief content.
export function applyPersonBriefFrame(
  partial: Record<string, any>,
  event: string,
  data: any
): Record<string, any> {
  if (event === "meta") {
    if (data?.linkedin_url) partial.url = data.linkedin_url
    if (data?.name) partial.name = data.name
    if (data?.organization_name)
      partial.organization_name = data.organization_name
  } else if (event === "enrich") {
    const payload = data?.payload || {}
    if (payload.name) partial.name = payload.name
    if (payload.title) partial.title = payload.title
    if (payload.organization_name)
      partial.organization_name = payload.organization_name
  } else if (event === "news") {
    if (data?.payload !== undefined) partial.news = data.payload
  } else if (event === "summary") {
    const payload = data?.payload || {}
    if (payload.summary && typeof payload.summary === "object") {
      // Full brief object: merge every field except the (large, unrendered)
      // prompt.
      const rest = { ...payload }
      delete rest.prompt
      Object.assign(partial, rest)
    } else {
      // Partial summary fields: merge (never wholesale-replace) so a
      // multi-frame summary can't discard earlier fields.
      const summaryFields = { ...payload }
      delete summaryFields.prompt
      partial.summary = { ...partial.summary, ...summaryFields }
    }
  }
  return partial
}
